export default {
  'signup.name': 'Persona',
  'signup.contact': 'Contact',
  'signup.password': 'Password',

  'signup.required-field': 'This field must be set',

  'signup.first-name': 'First name',
  'signup.last-name': 'Last name',
  'signup.sex': 'Sex',
  'signup.title': 'Title',
  'signup.prefix': 'Prefix',
  'signup.prefix.mr': 'Mr.',
  'signup.prefix.ms': 'Mrs.',
  'signup.prefix.other': 'Other',
  'signup.date-of-birth': 'Date of birth',
  'signup.prefix.tooltip': 'We guarantee that no personal data will be shared',
  'signup.sex.tooltip': 'We guarantee that no personal data will be shared',
  'signup.date-of-birth.tooltip': 'We guarantee that no personal data will be shared',
  'signup.summary': 'Summary',
  'signup.summary.description': 'Please check if the entered data is correct.',

  'signup.invalid-email': 'Please enter a valid e-mail address',
  'signup.invalid-phone': 'Invalid phone number',

  'signup.phone': 'Phone number',
  'signup.e-mail': 'Email',

  'signup.password.tooltip': 'Your password must contain more than {minCount} characters.',
  'signup.password-repetition': 'Password repetition',

  'password-validation.minLength': 'Password has at least {length} characters',
  'password-validation.number': 'Password contains a number',
  'password-validation.match': 'Passwords match',
  'password-validation.capital': 'Password contains capital letters',
  'password-validation.specialChar': 'Password contains a special character',

  'create-user': 'Create account',
  'create-user.success': 'Account was created successfully',
  'create-user.error': 'An error occurred while creating the account',
  'create-user.error.description':
    'Please check if you already have an account with the given email address.',
  'create-user.success.description': 'You can now log in with your access data',

  'captcha.solve': 'Please solve captcha',
  'captcha.error': 'Captcha could not be solved',

  'terms-and-conditions': 'T&C',
  privacy: 'Privacy policy',

  '2fa.error': 'Two-factor authentication failed',
  '2fa.error.description': 'Please check your input.',

  'password-mismatch': 'Please enter the same password twice',
  'change-password.error':
    'Password could not be changed. Please check the correctness of the old password.',

  'email-confirmation': 'Email confirmation',
  'email-confirmation.two-factor': 'Two-factor authentication',
  'email-confirmation.description':
    'You have been sent an email with a confirmation link. To sign up, please open the link in the email or enter the code from the email here.',

  'account-verification': 'Account verification',
  'account-verification.description':
    'We are pleased to welcome you to {tenant}. In order to fully use your account, verification of your email is required. To do so, click on the verification link sent to the email address you provided ({email}).',
  'account-verification.invalid-code': 'Invalid code - Please try again.',
  'account-verification.valid-until': 'Valid until',
  'account-verification.no-email': 'Didn’t receive an e-mail?',

  'email.resent': 'Email was sent again',
  'email.resent.description': 'Please check your email inbox for {email}',

  'error.login': 'Email or password incorrect. Please check your access data',

  'auth-required': 'Login required',
  'auth-required.description': 'You must be logged in to visit this page.',

  'back-to-booking': 'Back to booking',
  'back-to-destination': 'Back to the application',

  'confirmable-action.action-token-sent.email.title':
    'A confirmation link has been sent to your e-mail.',

  'confirmable-action.action-token-sent.email-partial.sub-title':
    'Please continue here after confirming the link.',
  'confirmable-action.action-token-sent.email-partial.done': 'I confirmed the link',

  'confirmable-action.action-token-sent.email-full.sub-title':
    "There's nothing left todo here. Please continue with the link.",
  'confirmable-action.action-token-sent.email-full.done': 'Okay',
  'confirmable-action.skip': 'Skip',

  'go-to-login': 'Go to log-in',
};
